import {
    map
} from 'lodash';

import icons from 'styles/icons/icons.scss';
import styles from './ValueTags.scss';

function SelectedValueTags({ values, onRemove, isReadOnly }) {
    return (
        <div className={styles.valueTags} data-cy="ValueTags-return">
            { map(values, (value) =>
                <div className={styles.value} key={Math.random()}>
                    <span className={styles.valueText} data-cy={'ValueTags-'+value}>{ value }</span>
                    { !isReadOnly &&
                        <span onClick={onRemove.bind(this, value) } data-cy={'ValueTagsBtn-'+styles.removeValue}
                            className={`${icons.materialIcons} ${styles.removeValue}`}>
                            clear
                        </span>
                    }
                </div>
            )}
        </div>
    );
}

export default SelectedValueTags;
